import React from "react";
import { Box, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { projectVersion } from "config/navConfig";

const HomeHelp: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        top: 143,
        right: 0,
        backgroundColor: "#fff",
        borderTopLeftRadius: "30px",
        borderBottomLeftRadius: "30px",
        width: 40,
        height: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        zIndex: 10,
      }}
    >
      <IconButton
        onClick={() => navigate(`${projectVersion}/innoflex-phase`)}
        sx={{
          backgroundColor: "#0033CC",
          color: "#fff",
          width: 22,
          height: 22,
          "&:hover": {
            backgroundColor: "#002299",
          },
        }}
      >
        <InfoIcon />
      </IconButton>
    </Box>
  );
};

export default HomeHelp;
